import { z } from 'zod';
import { zCents, zEmail, zId, zIso, zOptId, zOptText, zText } from './common';

export const signupQuestionSchema = z.object({
  key: z.string().regex(/^[a-z0-9_]{1,40}$/, 'Clave inválida'),
  label: zText(160),
  type: z.enum(['text', 'textarea', 'select', 'checkbox', 'number']),
  required: z.boolean().default(false),
  options: z.array(z.string().max(80)).max(50).default([]),
});

export const signupSchema = z
  .object({
    name: zText(160),
    description: zOptText(10000),
    campusId: zOptId,
    opensAt: zIso.nullable().optional(),
    closesAt: zIso.nullable().optional(),
    isPublic: z.boolean().default(true),
    maxAttendees: z.number().int().min(1).max(100000).nullable().optional(),
    waitlistEnabled: z.boolean().default(true),
    questions: z.array(signupQuestionSchema).max(50).default([]),
    status: z.enum(['draft', 'open', 'closed', 'archived']).default('draft'),
  })
  .refine((s) => !s.opensAt || !s.closesAt || new Date(s.closesAt) > new Date(s.opensAt), {
    message: 'El cierre debe ser posterior a la apertura',
    path: ['closesAt'],
  });

export const signupTimeSchema = z
  .object({ label: zOptText(80), startsAt: zIso, endsAt: zIso })
  .refine((t) => new Date(t.endsAt) > new Date(t.startsAt), { message: 'El fin debe ser posterior', path: ['endsAt'] });

export const selectionTypeSchema = z.object({
  name: zText(80),
  priceCents: zCents.default(0),
  capacity: z.number().int().min(1).max(100000).nullable().optional(),
  sortOrder: z.number().int().min(0).max(999).default(0),
});

export const registerSchema = z.object({
  registrantName: zText(160),
  registrantEmail: zEmail,
  attendees: z
    .array(
      z.object({
        personId: zOptId,
        firstName: zText(80),
        lastName: zText(80),
        selectionTypeId: zId,
        answers: z.record(z.string(), z.unknown()).default({}),
      }),
    )
    .min(1, 'Agrega al menos un asistente')
    .max(20),
});

export const registrationPaymentSchema = z.object({
  amountCents: z.number().int().min(1).max(1_000_000_000),
  method: z.enum(['cash', 'check', 'card', 'other']),
  note: zOptText(300),
});
